import axios from "axios";
import { APPCONFIG } from "../Config";
import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";
import { ACCESS_TOKEN } from "../lib/const";

export const getListDepartments = async () => {
  const api = `${APIEndpoint.GET_DEPARTMENT}`;

  const res = await axiosInstance.get(api);
  return res;
};

export const getListIndicators = async (id) => {
  const api = `${APIEndpoint.GET_INDICATOR}`;

  const res = await axiosInstance.get(api + `/?departmentId=${id}`);
  return res;
};

export const getListDivisions = async (id) => {
  const api = `${APIEndpoint.GET_DIVISION}`;

  const res = await axiosInstance.get(api + `/?departmentId=${id}`);
  return res;
};

export const getIndicatorById = async (id) => {
  const api = `${APIEndpoint.GET_INDICATOR_BY_ID_API}`;

  const res = await axiosInstance.get(api + `/${id}`);
  return res;
};

export const getListProjects = async (id) => {
  const api = `${APIEndpoint.GET_PROJECT}`;

  const res = await axiosInstance.get(api + `/?departmentId=${id}`);
  return res;
};

export const createIndicator = async (request) => {
  const api = APIEndpoint.CREATE_INDICATOR_API;

  const res = await axiosInstance.post(api, JSON.stringify(request));
  return res;
};

export const updateIndicatorsData = async (id, request) => {
  const api = APIEndpoint.UPDATE_INDICATOR_API + `/${id}`;

  const res = await axiosInstance.put(api, JSON.stringify(request));
  return res;
};

// Indicators
export const getIndicatorsListData = async () => {
  const api = `${APIEndpoint.GET_INDICATOR_LIST_DATA}`;

  const res = await axiosInstance.get(api);
  return res;
};

export const searchIndicators = (searchValue, pageValue) => {
  const api = `${APIEndpoint.SEARCH_INDICATOR_DATA}`;
  let payload = {
    requestObject: {
      name: searchValue.name ? searchValue.name : "",
      departmentId: searchValue.departmentId ? searchValue.departmentId : "",
      divisionId: searchValue.divisionId ? searchValue.divisionId : "",
      monthOfBudget: searchValue.monthOfBudget ? searchValue.monthOfBudget : "",
      yearOfBudget: searchValue.yearOfBudget ? searchValue.yearOfBudget : "",
    },
    pageValue: {
      page: pageValue.page,
      pageSize: pageValue.pageSize,
      sortBy: pageValue.sortBy,
      sortDirection: pageValue.sortDirection,
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};

export const deleteIndicators = async (id) => {
  const _id = id;
  const api = APIEndpoint.DELETE_INDICATOR_DATA + "/";
  const res = axiosInstance.delete(api + _id);
  return res;
};

// Performance
export const getPerformanceById = async (id) => {
  const api = `${APIEndpoint.GET_PERFOMANCE_BY_ID}`;

  const res = await axiosInstance.get(api + `/${id}`);
  return res;
};

export const getPerformanceListData = async (id) => {
  const api = `${APIEndpoint.GET_PERFOMANCE_LIST_DATA}`;

  const res = await axiosInstance.get(api);
  return res;
};

export const createPerformance = async (request) => {
  const api = APIEndpoint.CREATE_PERFOMANCE_API;

  const res = await axiosInstance.post(api, JSON.stringify(request));
  return res;
};

export const updatePerformance = async (id, request) => {
  const api = APIEndpoint.PUT_PERFOMANCE_LIST_DATA + `/${id}`;

  const res = await axiosInstance.put(api, JSON.stringify(request));
  return res;
};

export const searchPerformance = (searchValue, pageValue) => {
  const api = `${APIEndpoint.SEARCH_PERFOMANCE_DATA}`;
  let payload = {
    requestObject: {
      projectName: searchValue.projectName ? searchValue.projectName : "",
      departmentId: searchValue.departmentId ? searchValue.departmentId : "",
      divisionId: searchValue.divisionId ? searchValue.divisionId : "",
      monthOfBudget: searchValue.monthOfBudget ? searchValue.monthOfBudget : "",
      yearOfBudget: searchValue.yearOfBudget ? searchValue.yearOfBudget : "",
    },
    pageValue: {
      page: pageValue.page,
      pageSize: pageValue.pageSize,
      sortBy: pageValue.sortBy,
      sortDirection: pageValue.sortDirection,
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};

export const deletePerformance = async (id) => {
  const _id = id;
  const api = APIEndpoint.DELETE_PERFOMANCE_DATA + "/";
  const res = axiosInstance.delete(api + _id);
  return res;
};

export const getYearlyPlanList = async () => {
  const api = `${APIEndpoint.GET_YEARLYPLAN_LIST_API}`;

  const res = await axiosInstance.get(api);
  return res;
};

export const getYearlyPlanById = async (id) => {
  const api = `${APIEndpoint.GET_YEARLYPLAN_BY_ID}`;

  const res = await axiosInstance.get(api + `/${id}`);
  return res;
};

export const getIndicatorByYearlyPlan = async (searchValue) => {
  const api = `${APIEndpoint.GET_INDICATOR_BY_YEARLYPLAN}`;
  let payload = {
    requestObject: {
      departmentId: searchValue.departmentId,
      divisionId: searchValue.divisionId,
      yearOfBudget: searchValue.yearOfBudget,
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};

export const getProjectByYearlyPlan = async (searchValue) => {
  const api = `${APIEndpoint.GET_PROJECT_BY_YEARLYPLAN}`;
  let payload = {
    requestObject: {
      departmentId: searchValue.departmentId,
      divisionId: searchValue.divisionId,
      yearOfBudget: searchValue.yearOfBudget,
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};

export const getYearlProjectList = async () => {
  const api = `${APIEndpoint.GET_YEARLY_PROJECT_LIST_API}`;

  const res = await axiosInstance.get(api);
  return res;
};

export const getYearlProjectListYEAR = async () => {
  const api = `${APIEndpoint.GET_YEARLY_PROJECT_LIST_YEAR_API}`;

  const res = await axiosInstance.get(api);
  return res;
};

export const getListProjectByYear = async (searchValue) => {
  const api = `${APIEndpoint.GET_LIST_PROJECT_BY_YEAR}`;

  const res = await axiosInstance.get(
    api +
      `?year=${searchValue.year}&projectId=${searchValue.projectId}&size=200&page=0`
  );
  return res;
};

export const getListIndicatorByYear = async (searchValue) => {
  const api = `${APIEndpoint.GET_LIST_INDICATOR_BY_YEAR}`;

  const res = await axiosInstance.get(
    api +
      `?year=${searchValue.year}&indicatorId=${searchValue.indicatorId}&size=200&page=0`
  );
  return res;
};

// Project
export const createProjectData = async (request) => {
  const api = APIEndpoint.CREATE_PROJECT_API;

  const res = await axiosInstance.post(api, JSON.stringify(request));
  return res;
};

export const updateProjectData = async (id, request) => {
  const api = APIEndpoint.UPDATE_PROJECT_API + `/${id}`;

  const res = await axiosInstance.put(api, JSON.stringify(request));
  return res;
};

export const updateIndicatorByYear = async (request) => {
  const api = APIEndpoint.UPDATE_YEARLY_INDICATOR_API;

  const res = await axiosInstance.post(api, JSON.stringify(request));
  return res;
};

export const deleteProject = async (id) => {
  const _id = id;
  const api = APIEndpoint.DELETE_YEARLY_PROJECT_DATA + "/";
  const res = axiosInstance.delete(api + _id);
  return res;
};

export const getYearlyPlanBySearch = async (searchValue) => {
  const api = `${APIEndpoint.GET_YEARLYPLAN_SEARCH_API}`;
  let payload = {
    requestObject: {
      yearOfBudget: searchValue.yearOfBudget,
      projectId: searchValue.projectId,
      indicatorId: searchValue.indicatorId,
    },
    pageValue: {
      page: "0",
      pageSize: "10",
      sortBy: "createDate",
      sortDirection: "desc",
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};

export const getProjectByYearlyProject = async (searchValue) => {
  const api = `${APIEndpoint.GET_PROJECT_BY_YEARLYPROJECT}`;
  let payload = {
    requestObject: {
      departmentId: searchValue.departmentId,
      divisionId: searchValue.divisionId,
      yearOfBudget: searchValue.yearOfBudget,
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};

export const uploadFile = async (file) => {
  const api = `${APIEndpoint.UPLOAD_FILE_API}`;
  const formData = new FormData();
  formData.append("file", file);

  let options = {
    headers: { Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}` },
  };

  const res = axios.post(APPCONFIG.GATEWAY_ENDPOINT + api, file, options);
  return res;
};